import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  smartNav: {
    overflow: 'hidden',
    position: 'relative',
    '&.close': {
      width: '54px'
    }
  },
  smartNavContent: {
    width: '300px',
    backgroundColor: palette.common.white
    // boxShadow: '0px 32px 32px 0px rgba(0, 0, 0, 0.15)',
  },
  smartNavControll: {
    display: 'flex',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    alignItems: 'center',
    padding: '8px 8px 0 24px',
    justifyContent: 'space-between',
    fontFamily: palette.fontFamilies.poppins,
    '& span': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '&.close': {
      width: '54px',
      padding: '8px 8px 0 8px',
      justifyContent: 'center',
      '& span:first-child': {
        display: 'none'
      },
      '& .MuiSvgIcon-root': {
        transform: 'rotateZ(180deg)'
      },
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        top: '32px',
        zIndex: '98',
        content: '""',
        position: 'absolute',
        transition: 'all .3s ease',
        backgroundColor: '#ffffff'
      },
      '&:before': {
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '99',
        display: 'flex',
        fontSize: '18px',
        fontWeight: '600',
        color: '#8895a7',
        position: 'absolute',
        alignItems: 'center',
        content: '"Properties"',
        justifyContent: 'center',
        transform: 'rotate(-90deg)',
        fontFamily: 'Poppins, sans-serif'
      }
    }
  },
  smartNavControllTitle: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: palette.fontFamilies.poppins
  },
  smartNavSetting: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  smartNavSettingSearch: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& > div > div:first-child': {
      top: '6px',
      left: '10px'
    }
  },
  smartNavSettingFilter: {
    flexShrink: '0',
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      width: '28px',
      height: '28px',
      border: 'none',
      padding: '0',
      minWidth: '28px',
      minHeight: '28px',
      '& svg': {
        fontSize: '16px'
      }
    },
    '& > div + div': {
      marginLeft: '4px'
    }
  },
  smartNavBody: {
    overflowY: 'auto',
    height: 'calc(100vh - 230px - 26px)',
    '&.paymentMarginWarning': {
      height: 'calc(100vh - 230px - 26px - 53px)'
    },
    '&.paymentMarginWarningBoth': {
      height: 'calc(100vh - 230px - 26px - 100px)'
    },
    '& .MuiAccordion-root': {
      boxShadow: 'none'
    }
  },
  smartNavItem: {
    display: 'flex',
    color: palette.shades[700],
    cursor: 'pointer',
    minHeight: '54px',
    position: 'relative',
    alignItems: 'center',
    padding: '12px 9px 12px 36px',
    justifyContent: 'space-between',
    '&:hover': {
      color: palette.common.black,
      backgroundColor: palette.shades[200]
    },
    '&.empty': {
      padding: '12px 9px 12px 9px',
      '& > div': {
        maxWidth: '100%'
      }
    },
    '&.empty:hover': {
      color: 'unset',
      backgroundColor: 'unset',
      cursor: 'unset'
    },
    '&.active': {
      color: palette.common.black,
      backgroundColor: palette.shades[250],
      '&:after': {
        top: '0',
        right: '0',
        bottom: '0',
        width: '3px',
        content: '""',
        display: 'block',
        position: 'absolute',
        backgroundColor: palette.primary.main
      }
    },
    '& span .MuiButton-actionButtonPrimary': {
      minWidth: 'unset',
      minHeight: 'unset',
      width: '28px',
      height: '28px',
      margin: 'unset',
      padding: 'unset',
      marginLeft: '8px',
      '& .MuiSvgIcon-root': {
        width: '16px',
        height: '16px'
      }
    }
  },
  smartNavItemPortfolioAccordion: {
    '& .MuiAccordionSummary-root:hover': {
      color: palette.common.black,
      backgroundColor: palette.shades[250]
    }
  },
  smartNavItemPortfolio: {
    width: '100%',
    display: 'flex',
    color: palette.shades[700],
    cursor: 'pointer',
    minHeight: '54px',
    position: 'relative',
    alignItems: 'center',
    padding: '12px 9px 12px 0',
    justifyContent: 'space-between',
    '& span .MuiButton-actionButtonPrimary': {
      minWidth: 'unset',
      minHeight: 'unset',
      width: '28px',
      height: '28px',
      margin: 'unset',
      padding: 'unset',
      marginLeft: '8px',
      '& .MuiSvgIcon-root': {
        width: '16px',
        height: '16px'
      }
    }
  },
  smartNavItemIcon: {
    width: '21px',
    height: '21px',
    marginRight: '8px',
    position: 'relative',
    '& .MuiSvgIcon-root': {
      fontSize: '21px',
      display: 'block',
      '& path': {
        fill: '#00767C'
      }
    },
    '& i': {
      right: '-4px',
      bottom: '-4px',
      width: '16px',
      height: '16px',
      display: 'flex',
      borderRadius: '50%',
      position: 'absolute',
      alignItems: 'center',
      backgroundColor: '#fff',
      justifyContent: 'center',
      boxShadow: '0px 8px 12px 0px rgba(95, 107, 122, 0.25)',
      '& .MuiSvgIcon-root': {
        fontSize: '12px',
        display: 'block',
        '& path': {
          fill: '#8895A7'
        }
      }
    },
    '&.info': {
      '& .MuiSvgIcon-root': {
        '& path': {
          fill: '#8895A7'
        }
      }
    }
  },
  smartNavItemDetails: {
    width: '100%',
    maxWidth: '190px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '& .MuiTypography-root': {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      color: palette.shades[700],
      fontSize: '11px',
      display: 'block',
      lineHeight: '14px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  smartNavItemNumber: {
    height: '20px',
    padding: '0 6px',
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    marginLeft: '12px',
    borderRadius: '2px',
    backgroundColor: palette.warning.light,
    fontFamily: palette.fontFamilies.poppins
  },
  portfolioMatchCount: {
    flexShrink: 0,
    marginLeft: '8px',
    fontSize: '13px',
    fontWeight: '600',
    color: palette.shades[700],
    fontFamily: palette.fontFamilies.poppins
  },
  smartNavNoMatches: {
    display: 'block',
    textAlign: 'center',
    padding: '16px',
    fontSize: '16px'
  },
  smartNavItemDetailsEmpty: {
    textAlign: 'center'
  },
  smartNavItemDetailsEmptyCaption: {
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    fontFamily: palette.fontFamilies.poppins
  },
  smartNavItemDetailsEmptyAction: {
    marginTop: '10px'
  },
  smartNavCollapseAll: {
    color: '#00767C',
    fontSize: '11px',
    padding: '0 8px',
    fontWeight: '600',
    cursor: 'pointer',
    lineHeight: '25px',
    borderBottom: '1px solid #E1E7EC',
    fontFamily: palette.fontFamilies.poppins
  }
});
export default useStyles;